import problemTracking from './problemTracking';
import recallActivity from './recallActivity';
import abnormalClaimTracking from './abnormalClaimTracking';

export default {
    problemTracking,
    recallActivity,
    abnormalClaimTracking,
};
